export const COHORT_BEHAVIORAL_LIMITATIONS_URL =
    'https://posthog.com/docs/feature-flags/common-questions#why-cant-i-use-a-cohort-with-behavioral-filters-in-my-feature-flag'
